import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import { Checkbox } from '../../../components/ui/Checkbox';

const BasicInformationStep = ({ formData, setFormData, errors }) => {
  const professionalRoles = [
    { value: 'agent', label: 'Agent Musical' },
    { value: 'booker', label: 'Booker/Programmateur' },
    { value: 'promoter', label: 'Promoteur' },
    { value: 'venue_owner', label: 'Propriétaire de Lieu' },
    { value: 'event_organizer', label: 'Organisateur d\'Événements' },
    { value: 'business_dev', label: 'Développement Commercial' }
  ];

  const companyTypes = [
    { value: 'individual', label: 'Entrepreneur Individuel' },
    { value: 'sarl', label: 'SARL' },
    { value: 'sas', label: 'SAS' },
    { value: 'association', label: 'Association' },
    { value: 'other', label: 'Autre' }
  ];

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  return (
    <div className="space-y-6">
      <div className="bg-surface border border-border rounded-lg p-6">
        <h3 className="text-lg font-semibold text-foreground mb-4">
          Informations Personnelles
        </h3>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Input
            label="Prénom *"
            type="text"
            placeholder="Votre prénom"
            value={formData?.firstName || ''}
            onChange={(e) => handleInputChange('firstName', e?.target?.value)}
            error={errors?.firstName}
            required
          />
          
          <Input
            label="Nom de famille *"
            type="text"
            placeholder="Votre nom de famille"
            value={formData?.lastName || ''}
            onChange={(e) => handleInputChange('lastName', e?.target?.value)}
            error={errors?.lastName}
            required
          />
          
          <Input
            label="Adresse e-mail *"
            type="email"
            placeholder="votre.email@exemple.com"
            value={formData?.email || ''}
            onChange={(e) => handleInputChange('email', e?.target?.value)}
            error={errors?.email}
            required
            description="Utilisée pour la connexion et les communications"
          />
          
          <Input
            label="Téléphone *"
            type="tel"
            placeholder="+33 1 23 45 67 89"
            value={formData?.phone || ''}
            onChange={(e) => handleInputChange('phone', e?.target?.value)}
            error={errors?.phone}
            required
          />

          <Input
            label="Mot de passe *"
            type="password"
            placeholder="••••••••"
            value={formData?.password || ''}
            onChange={(e) => handleInputChange('password', e?.target?.value)}
            error={errors?.password}
            required
            description="Minimum 6 caractères"
          />
          <Input
            label="Confirmer le mot de passe *"
            type="password"
            placeholder="••••••••"
            value={formData?.confirmPassword || ''}
            onChange={(e) => handleInputChange('confirmPassword', e?.target?.value)}
            error={errors?.confirmPassword}
            required
          />
        </div>
      </div>
      <div className="bg-surface border border-border rounded-lg p-6">
        <h3 className="text-lg font-semibold text-foreground mb-4">
          Informations Professionnelles
        </h3>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Select
            label="Rôle Professionnel *"
            placeholder="Sélectionnez votre rôle"
            options={professionalRoles}
            value={formData?.professionalRole || ''}
            onChange={(value) => handleInputChange('professionalRole', value)}
            error={errors?.professionalRole}
            required
            description="Votre fonction principale dans l'industrie musicale"
          />
          
          <Input
            label="Nom de l'entreprise"
            type="text"
            placeholder="Nom de votre entreprise"
            value={formData?.companyName || ''}
            onChange={(e) => handleInputChange('companyName', e?.target?.value)}
            error={errors?.companyName}
          />
          
          <Select
            label="Type d'entreprise"
            placeholder="Sélectionnez le type"
            options={companyTypes}
            value={formData?.companyType || ''}
            onChange={(value) => handleInputChange('companyType', value)}
            error={errors?.companyType}
          />
          
          <Input
            label="SIRET (si applicable)"
            type="text"
            placeholder="12345678901234"
            value={formData?.siret || ''}
            onChange={(e) => handleInputChange('siret', e?.target?.value)}
            error={errors?.siret}
            description="Numéro d'identification de votre entreprise"
          />
        </div>
        
        <div className="mt-4">
          <Input
            label="Site web"
            type="url"
            placeholder="https://votre-site.com"
            value={formData?.website || ''}
            onChange={(e) => handleInputChange('website', e?.target?.value)}
            error={errors?.website}
            description="Votre site web professionnel ou portfolio en ligne"
          />
        </div>
      </div>
      <div className="bg-surface border border-border rounded-lg p-6">
        <h3 className="text-lg font-semibold text-foreground mb-4">
          Adresse Professionnelle
        </h3>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="md:col-span-2">
            <Input
              label="Adresse *"
              type="text"
              placeholder="123 Rue de la Musique"
              value={formData?.address || ''}
              onChange={(e) => handleInputChange('address', e?.target?.value)}
              error={errors?.address}
              required
            />
          </div>
          
          <Input
            label="Code postal *"
            type="text"
            placeholder="75001"
            value={formData?.postalCode || ''}
            onChange={(e) => handleInputChange('postalCode', e?.target?.value)}
            error={errors?.postalCode}
            required
          />
          
          <Input
            label="Ville *"
            type="text"
            placeholder="Paris"
            value={formData?.city || ''}
            onChange={(e) => handleInputChange('city', e?.target?.value)}
            error={errors?.city}
            required
          />
        </div>
      </div>
      <div className="bg-surface border border-border rounded-lg p-6">
        <h3 className="text-lg font-semibold text-foreground mb-4">
          Conditions d'utilisation
        </h3>
        
        <div className="space-y-3">
          <Checkbox
            label="J'accepte les conditions générales d'utilisation *"
            checked={formData?.acceptTerms || false}
            onChange={(e) => handleInputChange('acceptTerms', e?.target?.checked)}
            error={errors?.acceptTerms}
            required
            description="Vous devez accepter nos conditions pour continuer"
          />
          
          <Checkbox
            label="J'accepte de recevoir des communications marketing"
            checked={formData?.acceptMarketing || false}
            onChange={(e) => handleInputChange('acceptMarketing', e?.target?.checked)}
            description="Newsletters, offres spéciales et actualités du secteur"
          />
          
          <Checkbox
            label="J'accepte le traitement de mes données personnelles *"
            checked={formData?.acceptDataProcessing || false}
            onChange={(e) => handleInputChange('acceptDataProcessing', e?.target?.checked)}
            error={errors?.acceptDataProcessing}
            required
            description="Conformément au RGPD pour le traitement de votre inscription"
          />
        </div>
      </div>
    </div>
  );
};

export default BasicInformationStep;